import { cva } from '@vizit/theme';

/**
 * Shared container styles for product page performance metric cards
 * (score-metric-cell, asset-mix-v2, asset-count-v2, asset-order-v2).
 * Each card defines its own per-tier number colors.
 *
 * Each card is a standalone surface: its own background and a small drop
 * shadow, with no border. The parent row separates them with a gap.
 *
 * The intrinsic `w-[241px]` matches the natural width when these cells
 * render side-by-side inside the page performance card. Consumers that
 * place them in a flex row (the standard layout) override it with
 * `flex-1`, so it only affects standalone usage (e.g. Storybook).
 */

const METRIC_CARD_BASE = 'flex flex-col px-8 min-w-0 transition-all duration-350';

const metricCardContainer = cva({
  base: METRIC_CARD_BASE,
  variants: {
    state: {
      default: 'bg-primary shadow-xs',
      focused: 'bg-primary shadow-lg-soft',
      disabled: '',
    },
    size: {
      // Matches the page performance row's h-[155px] exactly; the row has no border
      // of its own, so the cells fill its full height.
      default: 'justify-between pb-3 pt-6 h-[155px]',
      compact: 'gap-6 py-6',
    },
  },
  defaultVariants: { state: 'default', size: 'default' },
});

export { metricCardContainer };
